<template>
  <div>
    <div class="right_items">
      <div class="img_show">
        <img
          src="@/assets/img/04-delivergoods.svg"
          alt
          srcset
        />
        <div
          class="node nodemodule_one"
          @click="toSaveClick"
          v-cust
        >
          <flow-popover
            :size="14"
            :title="`发货审批`"
            :check-data="offerCheckData"
          ></flow-popover>
        </div>
      </div>
    </div>
    <foot-bar @save="saveSubmit"></foot-bar>
    <flow-dialog
      :data-key="dataKey"
      :node-data="dialogData"
      :dialog-visible.sync="dialogVisible"
      @successEv="toSave"
    ></flow-dialog>
  </div>
</template>

<script>

import flowMixin from '@/mixin/flowMixin'

export default {
  name: 'deliverflow',
  mixins: [flowMixin],
  data () {
    return {
      offerCheckData: {}, // 报价审批
      specialCheckData: {} // 特价审批
    }
  },
  methods: {
    saveSubmit () {

    },
    toSaveClick () {
      this.dataKey = 'offerCheckData'
      this.showDialog()
    },
    toSaveClick_left () {
      this.dataKey = 'specialCheckData'
      this.showDialog()
    }
  }
}
</script>
<style
  scoped
  lang="less"
>
  @import "/src/assets/less/flow.less";

  .nodemodule_one {
    .common(106px, 46px, auto, 139px, 0);
  }
</style>
